import React, { Fragment } from "react";
import moment from "moment";
import map from "lodash/map";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.scss";

type Props = RouteComponentProps<any> & {
  trackOrder: any;
  handleTrackOrder?: () => void;
  showCrossIcon?: boolean;
};

const TrackOrderTimeline: React.FC<Props> = ({
  trackOrder,
  handleTrackOrder,
  showCrossIcon = false
}) => {
  const { t } = useTranslation("myAccount");
  let completeStatus =
    trackOrder.orderStatusDetails &&
    !!trackOrder.orderStatusDetails.length &&
    trackOrder.orderStatusDetails.findIndex(orderStatus => !orderStatus.status);

  return (
    <div className="track_order_wrapper">
      <div className="order_deliver_steps">
        {showCrossIcon && (
          <span className="cross-icon" onClick={handleTrackOrder} />
        )}
        <ul className="track_order_web">
          {map(trackOrder.orderStatusDetails, (orderStatus, idx) => (
            <li
              key={orderStatus.statusMessage}
              className={
                Number(idx) === completeStatus - 1
                  ? "coming_bar"
                  : Number(idx) < completeStatus - 1
                  ? "success_bar"
                  : completeStatus === -1
                  ? "success_bar"
                  : ""
              }
            >
              <div className="order_delivery_status">
                <h4>
                  {orderStatus.date &&
                    moment(orderStatus.date).format("DD MMM")}
                </h4>
                <p className="success">{t(orderStatus.statusMessage)}</p>
              </div>
            </li>
          ))}
        </ul>
        <ul className="track_order_mob">
          {map(trackOrder.orderStatusDetails, (orderStatus, idx) => (
            <li
              key={orderStatus.statusMessage}
              className={
                Number(idx) === completeStatus - 1
                  ? "coming_bar"
                  : Number(idx) < completeStatus - 1
                  ? "success_bar"
                  : completeStatus === -1
                  ? "success_bar"
                  : ""
              }
            >
              <div className="order_delivery_status">
                {trackOrder.orderStatusDetails.length + completeStatus >=
                trackOrder.orderStatusDetails.length ? (
                  completeStatus - 1 === Number(idx) ? (
                    <Fragment>
                      <h4>
                        {orderStatus.date &&
                          moment(orderStatus.date).format("DD MMM")}
                      </h4>
                      <p className="success">{t(orderStatus.statusMessage)}</p>
                    </Fragment>
                  ) : null
                ) : trackOrder.orderStatusDetails.length + completeStatus ===
                  idx ? (
                  <Fragment>
                    <h4>
                      {orderStatus.date &&
                        moment(orderStatus.date).format("DD MMM")}
                    </h4>
                    <p className="success">{t(orderStatus.statusMessage)}</p>
                  </Fragment>
                ) : null}
              </div>
            </li>
          ))}
        </ul>
        {trackOrder.courier && (
          <div className="delivery_mode">
            <h4>
              <span>Courier Name:</span> {trackOrder.courier}{" "}
            </h4>
          </div>
        )}
      </div>
      <div className="order_status_timeline">
        <ul>
          {map(trackOrder.trackingDetails, trackingDetails => (
            <li key={trackingDetails.traceDate}>
              <h4>
                {trackingDetails.traceDate && (
                  <>
                    {moment(trackingDetails.traceDate).format("DD MMM")},{" "}
                    <span>
                      {moment(trackingDetails.traceDate).format("LT")}
                    </span>
                  </>
                )}
              </h4>
              <p>{trackingDetails.status}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default withRouter(TrackOrderTimeline);
